import React, { memo } from 'react'
import styles from './RouteDoesntExist.module.scss'

type Props = {}

const RouteDoesntExist: React.FC<Props> = memo((props: Props) => {
    function goBack(){
        window.history.back()
    }

    return (
        <div className={styles.container}>
            <div className={styles.background}>
                <video id="background-video" autoPlay loop muted>
                    <source src="../../../videos/landing-page-video.webm" type="video/mp4" />
                </video>
            </div>

            <img src="../../../images/ekedc/logo.svg" alt='Logo' style={{width: '64px', height: '64px'}} />

            <div className={styles.content}>
                <h1 className={styles.statusCode}>404</h1>
                <h3 className={styles.title}>Oops! The page you're looking for doesn't exist.</h3>

                <p className={styles.info}>Sorry, the page you're looking for doesn't exist. If you think this is a mistake, please contact us.</p>

                <button className={`standardButton ${styles.contactButton}`}>Contact Us</button>

                <p className={styles.info}>Or you can go back to the previous page.</p>

                <button className={`standardButton ${styles.goBackButton}`} onClick={goBack}>Go Back</button>
            </div>
        </div>
    )
})

export default RouteDoesntExist